/**
 * Construction FormData pour POST/PUT /api/sites (champ multer : site_media).
 */
const FORCE_SEND_ON_NULL = new Set([
  'adr1',
  'adr2',
  'adr3',
  'cp',
  'ville',
  'latitude',
  'longitude',
  'observations',
  'commentaire'
]);

export function buildSiteFormData(siteData = {}) {
  const formData = new FormData();
  Object.entries(siteData).forEach(([key, value]) => {
    if (value === undefined || key === 'site_media') return;
    if (value === null) {
      if (FORCE_SEND_ON_NULL.has(key)) {
        formData.append(key, '');
      }
      return;
    }
    formData.append(key, value);
  });

  if (siteData.site_media instanceof File) {
    formData.append('site_media', siteData.site_media);
  }

  return formData;
}

export function hasSiteMediaFile(siteData = {}) {
  return siteData?.site_media instanceof File;
}
